import { Navigation } from "lucide-react";
import { MAPS_EMBED_URL, MAPS_DIRECTIONS_URL } from "@/lib/constants";
import { Reveal, MaskReveal } from "@/components/Reveal";
import FooterBottom from "@/components/FooterBottom";

export default function Footer() {
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="relative overflow-hidden border-t border-[#B08D2E]/15 bg-[#F4EFE4] pt-28 sm:pt-36"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="text-[11px] font-medium uppercase tracking-[0.4em] text-[#B08D2E]">
            Contact
          </p>
        </Reveal>
        <h2 className="mt-6 max-w-3xl font-display text-4xl font-light leading-[1.08] tracking-tight text-[#1A1A1A] sm:text-5xl lg:text-6xl">
          <MaskReveal>Visit us on</MaskReveal>
          <MaskReveal delay={0.12}>
            <em className="gold-text font-medium italic">the High Street.</em>
          </MaskReveal>
        </h2>

        <Reveal delay={0.15} className="mt-14 sm:mt-16">
          <div className="grid gap-6 lg:grid-cols-2">
            <div
              data-testid="storefront-image"
              className="group relative h-72 overflow-hidden rounded-2xl border border-[#B08D2E]/20 shadow-[0_18px_50px_rgba(26,26,26,0.1)] sm:h-96 lg:h-auto"
            >
              <img
                src="/images/storefront.jpg"
                alt="R&J Dry Cleaners storefront — 148 High Street, Yiewsley"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
              />
              <span className="absolute bottom-4 left-4 border border-[#D4AF37]/30 bg-[#0E1420]/80 px-4 py-2 text-[10px] font-medium uppercase tracking-[0.25em] text-[#F9F6F0] backdrop-blur-md">
                148 High Street · Yiewsley
              </span>
            </div>
            <div
              data-testid="contact-map"
              className="grid grid-rows-[220px_1fr] overflow-hidden rounded-2xl border border-[#B08D2E]/20 bg-[#FFFFFF] shadow-[0_18px_50px_rgba(26,26,26,0.08)] sm:grid-rows-[240px_1fr]"
            >
              <iframe
                title="R&J Dry Cleaners — 148 High St, Yiewsley, West Drayton"
                src={MAPS_EMBED_URL}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="h-full w-full opacity-95 grayscale-[0.35] sepia-[0.14] contrast-[0.95]"
              />
              <div className="flex flex-col justify-center border-t border-[#B08D2E]/15 p-8 sm:p-9">
              <p className="text-[10px] font-medium uppercase tracking-[0.4em] text-[#B08D2E]">
                Find the Shop
              </p>
              <p className="mt-5 font-display text-2xl font-light leading-snug text-[#1A1A1A]">
                148 High St, Yiewsley,
                <br />
                West Drayton UB7 7BD
              </p>
              <p className="mt-4 text-xs font-light leading-relaxed tracking-wide text-[#6E675C]">
                On the High Street, moments from Yiewsley &amp; West Drayton
                station. Walk-ins welcome during opening hours.
              </p>
              <a
                data-testid="get-directions-btn"
                href={MAPS_DIRECTIONS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group mt-7 inline-flex items-center gap-3 border border-[#B08D2E]/40 px-7 py-3.5 text-[10px] font-medium uppercase tracking-[0.28em] text-[#B08D2E] transition-[background-color,border-color] duration-300 hover:border-[#B08D2E] hover:bg-[#B08D2E]/10"
              >
                <Navigation className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.5} />
                Get Directions
              </a>
              </div>
            </div>
          </div>
        </Reveal>

      </div>

      <FooterBottom />
    </footer>
  );
}
